import Header from './Component/Header'
import Header2 from './Component/Header2'
import {Routes, Route} from "react-router-dom";
// import Home from './Component/Home';
import About from './Component/About';
import Portfolio from './Component/Portfolio';
import Contact from './Component/Contact';
import Clavr from './Component/Clavr';
import Todo from './Component/Todo';
import Green from './Component/Green';
import Tree from './Component/Tree';
import Vstream from './Component/Vstream';
import Resume from './Component/Resume';
import Panion from './Component/Panion';
import NotFound from './Component/NotFound';







function App() {
  return (
    <div>
      <Header/>
      <Header2/>
      <Routes>
        {/* <Route path='/' exact element={<Home/>} />  */}
        <Route path='/About' exact element={<About/>} /> 
        <Route path='/' exact element={<Portfolio/>} /> 
        <Route path='/Contact' exact element={<Contact/>} />          
        <Route path='/Clavr' exact element={<Clavr/>} />            
        <Route path='/Todo' exact element={<Todo/>} />            
        <Route path='/Green' exact element={<Green/>} />            
        <Route path='/Tree' exact element={<Tree/>} />            
        <Route path='/Vstream' exact element={<Vstream/>} />            
        {/* <Route path='/Resume' exact element={<Resume/>} />             */}
        <Route path='/Panion' exact element={<Panion/>} />            
        <Route path='*' exact element={<NotFound/>} />            
      </Routes> 
    </div>
  ); 
}

export default App;
